import ser from "../assets/img/365service1.png";
import ser2 from "../assets/img/365service2.png";
import ser3 from "../assets/img/365service3.png";
import Ebube from "../assets/img/ebube.png";
import Chibuzo from "../assets/img/chibuzo.png";
import Adewale from "../assets/img/adewale.png";
// import Poster from "../assets/img/testimony.png";
import Abubakar from "../assets/img/abubakar.png";
import Nneka from "../assets/img/nneka.png";
import Check from "../assets/check.svg";
import Quote from "../assets/Quote.svg";
import Profile from "../assets/img/profile-circle.png";
import ScrollingLogos from "../components/ScrollingLogos";
import Accordion from "../components/faq";
import { Link } from "react-router-dom";
import { getAllCountries } from "../data/countriesDatabase";
// import AboutBg from "../assets/img/365hero1.png";
// import ImageSlider from "../components/HeroSlider";
import HeroSlider from "../components/HeroSlider";
import { VideoPlayer } from "../components/Videoplayer";

const testimonies = [
  {
    id: 1,
    description:
      "I am grateful for the exceptional support and guidance from 365 Global Consulting. From school selection to visa application, they provided personalized assistance that made all the difference. Thanks to them, I'm now studying at my dream school with significant scholarship! I highly recommend their services to anyone looking to study abroad.",
    img: Ebube,
    degree: "International Relations and Affairs",
    name: "Ebube Akanno",
    school: "Drew University, USA",
  },
  {
    id: 2,
    description:
      "I'm deeply grateful to 365 Global Consulting for their exceptional guidance throughout my application process. Despite the tight deadline, they secured a spot for me and expedited my CAS. Their expertise and connections made all the difference. I highly recommend them to anyone seeking top-notch education consulting services.",
    img: Chibuzo,
    degree: "MSc Advanced Physiotherapy",
    name: "Chibuzo Akuneziri",
    school: "MMU, UK",
  },
  {
    id: 3,
    description:
      "The whole process was very easy. From selecting the right school that fit my budget and proposed course, getting the right information and also swift admission. It was so seamless and I'm forever grateful for the help. The communication was top-notch and I can boldly say they went above and beyond. I highly recommend",
    img: Nneka,
    degree: "Digital media and communications",
    name: "Nneka Adubor",
    school: "Teesside University, UK",
  },
  {
    id: 4,
    description:
      "I highly recommend 365 Global Consulting for their outstanding services. They provided exceptional support throughout my university admission process. They assisted me and my brothers with securing admission, obtaining visas, and arranging accommodation, all with remarkable professionalism and care. Their attention to detail and genuine dedication set them apart, making what could have been a daunting process smooth and stress-free. 365 Global truly goes above and beyond, and I’m grateful for their help in making my academic dreams a reality.",
    img: Abubakar,
    degree: "Software Engineering",
    name: "Abubakar Ali Yusuf",
    school: "University of Southampton, UK",
  },
  {
    id: 5,
    description:
      "They really helped me a lot and made the whole process relatively easy. My experience with them was top notch and their staff were there for me all through the process. I would recommend 365 global consulting for anyone who wants to get admission to study abroad. They are the best.",
    img: Adewale,
    degree: "MSc",
    name: "Adewale Ogedengbe",
    school: "Ulster Uni. Birmigham, UK",
  },
  {
    id: 6,
    description:
      "365 Global Consulting provided exceptional guidance and support throughout my daughter's admission process. Her expertise and dedication were invaluable, particularly with scholarship applications. She encouraged my daughter to strive for excellence, and her efforts paid off - she secured a scholarship! 365 Global Consulting assistance extended beyond admission. She offered phenomenal support as my daughter settled into the new environment, addressing every challenge with empathy and solutions. Her commitment to ensuring a smooth transition was remarkable. 365 Global Consulting ……professionalism, kindness, and genuine interest in my daughter's success made all the difference. I wholeheartedly recommend her services to anyone seeking a trusted education consultant. Thank you, 365 Global Consulting , for your outstanding support and guidance. Your impact on our journey has been immeasurable!",
    img: Profile,
    degree: "A level",
    name: "Mrs Adebisi",
    school: "Padworth college, Reading, UK",
  },
  {
    id: 7,
    description:
      "365 Global Consulting helped with my Visa application they gave excellent consultation on all the necessary documents needed and were very patient throughout the whole process they also carry you along booking all the appointments needed they were very transparent which makes them reliable, you will surely be getting your money's worth every step of the way.",
    img: Profile,
    degree: "MSc, Business Administration",
    name: "Fadesola Halima Belo",
    school: "University of Canada West",
  },
  {
    id: 8,
    description:
      "I had the most amazing experience with 365 Global Consulting. My agent was very friendly to me she helped me a lot when I was almost stuck in a situation whereby I couldn't process my admission, they make everything so easy for you and stress free. Literally my agent did everything for me. I would certainly suggest them to any other person who is having issues with his/her admission.",
    img: Profile,
    degree: "BS (Hons), Business Computing & IT ",
    name: "Akilu Mohammed Nawaf",
    school: "OnCampus Aston, UK",
  },
  {
    id: 9,
    description:
      "I am extremely impressed with the service 356 global consulting provides. They make university application very easy and less stressful,they handled every single thing for me. Not to forget how friendly my agent was and how she made sure I got everything I wanted,she has also been very supportive towards my academic concerns and I love that she keeps motivating and sending her prayers. I will forever be grateful especially for her kindness.Overall I would say their service is nothing less than a 10,and I would recommend them to any other person looking for a university agent.",
    img: Profile,
    degree: "LLB (Hons) Law IP",
    name: "Rabia Anwar Isyaku",
    school: "University of Portsmouth, UK",
  },
  {
    id: 10,
    description:
      "They were always willing to help me out and guide me through situation, it didn't matter what time of the day. I was absolutely impressed by their services and would definitely recommend.",
    img: Profile,
    degree: "Marketing with Digital Communication",
    name: "Ezinne Samuels",
    school: "London South Bank University, UK",
  },
];

export default function Home() {
  const countries = getAllCountries();

  return (
    <div className="container mx-auto gap-4">
      <div className="block bg-white h-[130px]"></div>
      <main className="flex flex-col gap-8 row-start-2 items-center sm:items-start">
        <HeroSlider />

        {/* <div className="relative w-full  md:h-full overflow-hidden group rounded-3xl">
          <img
            src={AboutBg}
            alt="Background"
            className="w-full h-full object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
          />

          <div className="absolute inset-0 flex items-start justify-center text-white p-10  flex-col gap-8">
            <h1 className="capitalize text-3xl md:text-6xl md:w-1/2 font-bold">
              study abroad <span className="text-secondary">made</span> easy
            </h1>
            <p className="md:w-80">
              Let’s guide you through every step of the application process to
              any university of your choice
            </p>
            <div>
              <a
                href="/application"
                className="uppercase bg-secondary py-3 px-6 rounded-full hover:bg-gray-cool duration-300"
              >
                get started
              </a>
            </div>
          </div>
        </div> */}

        <div className="mx-auto text-center mt-6 p-4">
          <h3 className="text-2xl md:text-4xl text-primary font-bold">
            Study Abroad with 365 Global Consulting
          </h3>
          <p className="mx-auto md:w-3/5 py-8 opacity-60">
            At 365 Global Consulting, we specialize in helping students navigate
            the complexities of studying abroad. Our expert counselors provide
            tailored guidance for school selection, application processing, and
            visa support, ensuring a smooth journey from start to finish.
          </p>
          <div className="flex flex-wrap gap-10 justify-center mb-10">
            <div className="flex gap-2">
              <img src={Check} alt="check" width={24} height={24} />
              <p> No crazy service charges</p>
            </div>
            <div className="flex gap-2">
              <img src={Check} alt="check" width={24} height={24} />
              <p> Expertise you can trust</p>
            </div>
            <div className="flex gap-2">
              <img src={Check} alt="check" width={24} height={24} />
              <p> Total transparency</p>
            </div>
          </div>
          <a
            href="/application"
            className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
          >
            schedule a free consultation
          </a>
        </div>
        <div className="mx-auto w-full text-center mt-20 bg-alice-blue py-20 sm:rounded-3xl">
          <h3 className="text-2xl md:text-4xl text-primary font-bold">
            We Help With
          </h3>

          <div className="flex flex-wrap gap-10 justify-center my-16">
            <div className="flex flex-col items-center justify-between overflow-hidden h-[460px] w-[300px] bg-white border border-gray-neutral rounded-3xl group">
              <h5 className="font-bold text-xl py-5"> School Selection</h5>
              <p className="text-base px-4 opacity-80">
                {" "}
                At our agency, we understand that this decision is influenced by
                many factors, each of which plays a crucial role in shaping a
                student’s educational experience and future career.
              </p>
              <div className="overflow-hidden group">
                <img
                  src={ser3}
                  alt="service"
                  width={300}
                  height={214}
                  className="object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
            </div>
            <div className="flex flex-col items-center justify-between overflow-hidden h-[460px] w-[300px] bg-white border border-gray-neutral rounded-3xl group">
              <h5 className="font-bold text-xl pt-5">
                {" "}
                Consultation and Counselling
              </h5>
              <p className="text-base px-4 opacity-80">
                {" "}
                We provide industry-standard guidance to students and their
                families regarding the various options for studying abroad.
              </p>
              <div className="overflow-hidden group">
                <img
                  src={ser}
                  alt="service"
                  width={300}
                  height={214}
                  className="object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
            </div>
            <div className="flex flex-col items-center justify-between overflow-hidden h-[460px] w-[300px] bg-white border border-gray-neutral rounded-3xl group">
              <h5 className="font-bold text-xl pt-5">
                {" "}
                Application & Documentation
              </h5>
              <p className="text-base px-4 opacity-80 my-4">
                {" "}
                Our expert team offers personalized assistance in gathering
                essential documentation, including academic transcripts,
                standardized test scores, and compelling letters
              </p>
              <div className="overflow-hidden group">
                <img
                  src={ser2}
                  alt="service"
                  width={300}
                  height={214}
                  className="object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
            </div>
          </div>
          <a
            href="/services"
            className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-500"
          >
            view our services
          </a>
        </div>
        <div className="mx-auto w-full text-center mt-20 rounded-3xl">
          <h3 className="text-2xl md:text-4xl text-primary capitalize font-bold">
            Study anywhere in <br />
            <span className="text-secondary">the world</span>
          </h3>

          <div className="flex flex-wrap justify-center gap-6 my-16">
            {countries.slice(0, 4).map((country) => (
              <div className="flex flex-col justify-between items-center gap-2 w-[300px] p-1 mb-6 bg-white border border-gray-neutral rounded-3xl  ">
                <Link
                  to={`/destination/${country.code}`}
                  className="cursor-pointer"
                >
                  <div className="relative group overflow-hidden rounded-3xl">
                    <img
                      src={country.thumbnail}
                      alt="destinations"
                      width={300}
                      height={214}
                      className="h-full min-h-[286px] object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute bg-secondary rounded-full px-3 py-1 top-2 left-2 text-white">
                      {country.name}
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 p-4 text-white"></div>
                    </div>
                    {/* <img src={country.flag} alt="check" width={24} height={24} className="absolute bottom-3 right-3"/> */}

                    <div className="absolute bottom-3 right-3 text-3xl">
                      {" "}
                      {country.flag}
                    </div>
                  </div>
                </Link>
                <p className="text-base px-4 opacity-80 py-3">
                  {" "}
                  {country.description}
                </p>
                <Link
                  to={`/destination/${country.code}`}
                  className="uppercase border group gap-3 flex border-primary text-primary mb-3 py-3 px-8 rounded-full hover:bg-gray-cool hover:text-white duration-500"
                >
                  See destination
                  <svg
                    className="transition-colors duration-500 group-hover:fill-secondary"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.00024 13.5L18.5862 13.5L13.2932 18.793C13.1987 18.8855 13.1234 18.9958 13.0718 19.1176C13.0202 19.2393 12.9932 19.3701 12.9925 19.5024C12.9917 19.6347 13.0173 19.7658 13.0675 19.8881C13.1178 20.0104 13.1919 20.1216 13.2854 20.2151C13.3789 20.3086 13.4901 20.3826 13.6124 20.4329C13.7348 20.4832 13.8659 20.5087 13.9981 20.5079C14.1304 20.5071 14.2612 20.4802 14.383 20.4285C14.5047 20.3769 14.615 20.3016 14.7075 20.207L21.7075 13.207C21.895 13.0195 22.0003 12.7652 22.0003 12.5C22.0003 12.2348 21.895 11.9805 21.7075 11.793L14.7075 4.793C14.6147 4.69996 14.5045 4.62618 14.3831 4.57589C14.2617 4.52561 14.1316 4.49982 14.0002 4.5C13.8025 4.50004 13.6092 4.55871 13.4448 4.6686C13.2804 4.77848 13.1522 4.93465 13.0766 5.11735C13.0009 5.30005 12.9811 5.50108 13.0197 5.69503C13.0582 5.88899 13.1534 6.06715 13.2932 6.207L18.5862 11.5L3.00024 11.5C2.73502 11.5 2.48067 11.6054 2.29313 11.7929C2.10559 11.9804 2.00024 12.2348 2.00024 12.5C2.00024 12.7652 2.10559 13.0196 2.29313 13.2071C2.48067 13.3946 2.73502 13.5 3.00024 13.5Z"
                      fill="#1F2041"
                      className="group-hover:fill-white"
                    />
                  </svg>
                </Link>
              </div>
            ))}
          </div>
          <div>
            <a
              href="/destinations"
              className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-500"
            >
              view all destinations
            </a>
          </div>
        </div>

        <div className="mx-auto text-center mt-20">
          <h3 className="text-2xl md:text-4xl text-primary font-bold">
            Choose from over{" "}
            <span className="text-secondary">500+ Schools</span> <br />
            to study abroad
          </h3>
          <div>
            <ScrollingLogos />
          </div>
          {/* <a
            href="/"
            className="mt-12 uppercase text-white bg-primary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
          >
            schedule a consultation
          </a> */}
        </div>

        <div className="mt-20 relative testimony bg-primary h-90 w-full p-8 md:rounded-3xl">
          <h3 className="text-2xl md:text-4xl text-center text-white my-8 font-bold">
            2000+ Happy Clients Around <br />
            The World
          </h3>
          <div className="overflow-x-scroll flex space-x-6 mt-20">
            {testimonies.map((testimony) => (
              <div
                key={testimony.id}
                className="max-w-[300px] h-full bg-white p-4 rounded-3xl flex-shrink-0"
              >
                <div>
                  <img src={Quote} alt="qoute" />
                  <div className="relative my-4">
                    <div className="h-[100px] overflow-y-scroll scrollbar-hide">
                      <p className="text-sm my-4 pr-2">
                        “{testimony.description}”
                      </p>

                      {/* Gradient overlay */}
                      <div className="absolute bottom-0 left-0 right-0 h-6 bg-gradient-to-t from-white"></div>
                    </div>
                  </div>
                  {/* <p className="text-xs my-4">“{testimony.description}”</p> */}
                  <div className="flex items-center gap-2">
                    <img
                      src={testimony.img}
                      alt=""
                      width={50}
                      className="rounded-full"
                    />
                    <div>
                      <p className="text-primary text-xs font-semibold">
                        {testimony.name},
                      </p>
                      <p className="text-primary text-[10px] font-semibold">
                        {testimony.degree}
                      </p>
                      <p className=" text-xs">{testimony.school}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="container mx-auto mt-12">
          <h3 className="text-3xl md:text-5xl text-center text-primary font-bold">
            Hear directly from <span className="text-white bg-gray-cool px-2">our students</span>
          </h3>
        </div>

        <div className="pb-3 w-full p-4">
          <div className="flex gap-3 overflow-x-auto scrollbar-hide">
            <div className="flex-none h-[550px] mx-auto mt-2">
              <VideoPlayer
                src="https://res.cloudinary.com/dxrjjhk9o/video/upload/v1739272767/Meet_Osaze_1_isx6d9.mp4"
                className="max-h-[550px] shadow-lg rounded-3xl"
                autoPlay={false}
                muted={false}
                loop={false}
                onEnded={() => console.log("Video finished")}
              />
            </div>
            <div className="flex-none h-[550px] mx-auto mt-2">
              <VideoPlayer
                src="https://res.cloudinary.com/dxrjjhk9o/video/upload/v1740991113/Ayomide_HB_hliqou.mp4"
                className="max-h-[550px] shadow-lg rounded-3xl"
                autoPlay={false}
                muted={false}
                loop={false}
                onEnded={() => console.log("Video finished")}
              />
            </div>
            <div className="flex-none h-[550px] mx-auto mt-2">
              <VideoPlayer
                src="https://res.cloudinary.com/dxrjjhk9o/video/upload/v1740991111/Patrick_HB_ydypgm.mp4"
                className="max-h-[550px] shadow-lg rounded-3xl"
                autoPlay={false}
                muted={false}
                loop={false}
                onEnded={() => console.log("Video finished")}
              />
            </div>
          </div>
        </div>

        <div className="mt-20 p-4">
          <h2 className="capitalize text-3xl md:text-5xl font-bold text-primary mb-6 md:my-12 leading-snug">
            frequently asked <br />
            <span className="text-secondary">questions</span>
          </h2>
          <Accordion />
        </div>
      </main>
    </div>
  );
}
